<template>
  <div class="pb-2">
    <div v-if="loadpage == true" class="text-center">
      <b-spinner
        style="width: 5rem; height: 5rem;"
        variant="primary"
        label="Large Spinner"
      />
    </div>
    <div v-if="loadpage == false">
      <b-card no-body>
        <b-card-header class="d-flex justify-content-between align-items-center">
          <h4 class="mb-0">รายการผู้ดูแลระบบ</h4>
          <b-button variant="primary" size="sm" @click="openAddModal()">
            + เพิ่ม Admin
          </b-button>
        </b-card-header>
        <hr class="my-0 mx-2">
        <b-card-body>
          <div class="d-md-flex">
            <div class="px-0 pb-1 pb-md-0 col-12 col-md-1">ค้นหา :</div>
            <div class="px-0 pb-1 pb-md-0 col-12 col-md-4">
              <b-form-input v-model="searchText" placeholder="ชื่อ / UserID / เบอร์โทร / Email" />
            </div>
            <div class="px-0 px-md-1 col-12 col-md-2">
              <b-button @click="reloadList()" variant="primary">
                ค้นหา
              </b-button>
            </div>
          </div>
        </b-card-body>
        <b-card-body>
          <div class="text-right">จำนวน : {{ totalRows }}</div>
          <b-table
            responsive
            :items="adminList"
            :fields="adminFields"
            table-class="table-md-responsive text-nowrap"
          >
            <template #cell(no)="data">
              {{ data.index + 1 + ((currentPage - 1) * perPage) }}
            </template>
            <template #cell(isMaster)="data">
              <b-badge v-if="data.value" variant="success">Master</b-badge>
              <span v-else>-</span>
            </template>
            <template #cell(actions)="data">
              <b-button
                size="sm"
                variant="outline-warning"
                class="mr-1"
                :disabled="!canEdit(data.item)"
                @click="openEditModal(data.item)"
              >
                แก้ไข
              </b-button>
              <b-button
                v-if="data.item.isMaster != true"
                size="sm"
                variant="outline-danger"
                :disabled="!canDelete(data.item)"
                @click="confirmDelete(data.item)"
              >
                ลบ
              </b-button>
            </template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="mt-0"
          />
        </b-card-body>
      </b-card>
    </div>

    <!-- Add / Edit Admin Modal -->
    <b-modal
      id="adminModal"
      ref="adminModal"
      @hidden="hideModal"
      title-class="h2"
      :title="isEdit ? 'แก้ไขข้อมูล Admin' : 'เพิ่ม Admin ใหม่'"
      hide-footer
      content-class="shadow"
      no-close-on-backdrop
      size="lg"
    >
      <b-form>
        <b-card-body class="py-0 px-0">
          <b-row>
            <b-col cols="12" md="6">
              <b-form-group label="ชื่อจริง *">
                <b-form-input v-model="form.firstName" placeholder="ชื่อจริง" />
                <span v-if="val.firstName === false" style="color:red">กรุณากรอกชื่อจริง</span>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="นามสกุล">
                <b-form-input v-model="form.lastName" placeholder="นามสกุล" />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="Email">
                <b-form-input v-model="form.email" type="email" placeholder="email@example.com" />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="เบอร์โทรศัพท์ *">
                <b-form-input v-model="form.phoneNumber" placeholder="0812345678" />
                <span v-if="val.phoneNumber === false" style="color:red">กรุณากรอกเบอร์โทรศัพท์</span>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="UserID *">
                <b-form-input v-model="form.userID" placeholder="UserID" :disabled="isEdit" />
                <span v-if="val.userID === false" style="color:red">กรุณากรอก UserID</span>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group :label="isEdit ? 'Credential (เว้นว่างหากไม่เปลี่ยน)' : 'Credential *'">
                <b-form-input v-model="form.password" type="password" placeholder="Credential" />
                <span v-if="val.password === false" style="color:red">กรุณากรอก Credential</span>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group>
                <b-form-checkbox
                  v-model="form.isMaster"
                  :disabled="!canSetMaster()"
                >
                  ผู้ใช้หลัก
                </b-form-checkbox>
                <small v-if="!canSetMaster()" class="text-muted">
                  มี Master อยู่แล้วในสาขานี้ ไม่สามารถตั้ง Master ซ้ำได้
                </small>
              </b-form-group>
            </b-col>
          </b-row>

          <hr />

          <h5 class="mb-1 font-weight-bold">สิทธิ์ผู้ใช้</h5>
          <div class="permission-list">
            <template v-for="parent in parentMenus">
              <div :key="'p-' + parent.permissionMenuID" class="permission-row">
                <div class="permission-name">
                  <b-form-checkbox
                    :checked="parent.authorize > 0"
                    @change="toggleMenu(parent, $event, true)"
                  >
                    <span class="font-weight-bold">{{ parent.nameTH }}</span>
                  </b-form-checkbox>
                </div>
                <div class="permission-radios">
                  <b-form-radio
                    v-model="parent.authorize"
                    :name="'perm-' + parent.permissionMenuID"
                    :value="1"
                    :disabled="parent.authorize === 0"
                    @change="onAuthorizeChange(parent, 1, true)"
                    plain
                    class="mr-2"
                  >
                    ดู
                  </b-form-radio>
                  <b-form-radio
                    v-model="parent.authorize"
                    :name="'perm-' + parent.permissionMenuID"
                    :value="2"
                    :disabled="parent.authorize === 0"
                    @change="onAuthorizeChange(parent, 2, true)"
                    plain
                  >
                    แก้ไข
                  </b-form-radio>
                </div>
              </div>
              <div
                v-for="child in getChildren(parent.permissionMenuID)"
                :key="'c-' + child.permissionMenuID"
                class="permission-row"
              >
                <div class="permission-name">
                  <b-form-checkbox
                    class="permission-indent"
                    :checked="child.authorize > 0"
                    @change="toggleMenu(child, $event, false)"
                  >
                    <span class="text-body">{{ child.nameTH }}</span>
                  </b-form-checkbox>
                </div>
                <div class="permission-radios">
                  <b-form-radio
                    v-model="child.authorize"
                    :name="'perm-' + child.permissionMenuID"
                    :value="1"
                    :disabled="child.authorize === 0"
                    plain
                    class="mr-2"
                  >
                    ดู
                  </b-form-radio>
                  <b-form-radio
                    v-model="child.authorize"
                    :name="'perm-' + child.permissionMenuID"
                    :value="2"
                    :disabled="child.authorize === 0"
                    plain
                  >
                    แก้ไข
                  </b-form-radio>
                </div>
              </div>
            </template>
          </div>
        </b-card-body>

        <div class="pt-1 d-flex justify-content-end">
          <b-button variant="outline-secondary" size="sm" class="mr-1" @click="$refs['adminModal'].hide()">
            ยกเลิก
          </b-button>
          <b-button
            v-if="!isEdit"
            @click="submitAdd()"
            variant="primary"
            size="sm"
            :disabled="loadButton === false"
          >
            <b-spinner v-if="loadButton === false" small />
            เพิ่ม Admin
          </b-button>
          <b-button
            v-else
            @click="submitEdit()"
            variant="warning"
            size="sm"
            :disabled="loadButton === false"
          >
            <b-spinner v-if="loadButton === false" small />
            บันทึกการแก้ไข
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import {
  BFormGroup, BPagination, BFormInput, BButton, BCardBody, BCard, BSpinner, BRow, BCol,
  BFormCheckbox, BCardHeader, BFormRadio, BModal, BForm, BTable, BBadge,
} from 'bootstrap-vue'
import { header_token } from '@/views/token.js'
import { taobaoService_dotnet } from '@/views/global.js'
import axios from 'axios'

export default {
  name: 'AdminBranchSetting',

  components: {
    BSpinner, BCard, BCardBody, BCardHeader, BFormInput, BTable, BPagination,
    BButton, BModal, BForm, BFormGroup, BRow, BCol, BFormCheckbox, BFormRadio, BBadge,
  },

  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),

      searchText: '',

      adminList: [],
      adminFields: [
        { key: 'no', label: 'ลำดับ', thClass: 'text-center px-0', tdClass: 'text-center px-0' },
        { key: 'firstName', label: 'ชื่อ', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'lastName', label: 'นามสกุล', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'userID', label: 'UserID', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'email', label: 'Email', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'phoneNumber', label: 'เบอร์โทร', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'isMaster', label: 'ประเภท', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'actions', label: 'จัดการ', thClass: 'text-center', tdClass: 'text-center' },
      ],
      perPage: 10,
      currentPage: 1,
      totalRows: 0,

      isEdit: false,
      loadButton: true,
      form: {
        adminID: null,
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        userID: '',
        password: '',
        isMaster: false,
      },
      val: {
        firstName: null,
        phoneNumber: null,
        userID: null,
        password: null,
      },

      permissionRows: [],

      loadpage: true,
    }
  },

  computed: {
    currentAdminID() {
      return this.userData && this.userData.data ? this.userData.data.customerID : null
    },
    branchID() {
      return this.userData && this.userData.data ? this.userData.data.branchID : null
    },
    currentAdmin() {
      return this.adminList.find(x => x.adminID === this.currentAdminID) || null
    },
    isCurrentMaster() {
      return this.currentAdmin ? !!this.currentAdmin.isMaster : false
    },
    existingMaster() {
      return this.adminList.find(x => x.isMaster) || null
    },
    parentMenus() {
      return this.permissionRows
        .filter(m => !m.parentID)
        .slice()
        .sort((a, b) => (a.orderNo || 0) - (b.orderNo || 0))
    },
  },

  watch: {
    async currentPage() {
      await this.getAdminList()
    },
  },

  async created() {
    await this.getAdminList()
    this.loadpage = false
  },

  methods: {
    async getAdminList() {
      const skip = (this.currentPage - 1) * this.perPage
      try {
        const response = await axios.post(
          taobaoService_dotnet + 'app/Branch/get-admin-list',
          {
            branchID: this.branchID,
            keyword: this.searchText.trim(),
            skip,
            take: this.perPage,
          },
          { headers: header_token },
        )
        this.totalRows = response.data.totalRows || 0
        this.adminList = response.data.items || []
      } catch (e) {
        console.error(e)
        this.$bvToast.toast('โหลดรายการ Admin ไม่สำเร็จ', {
          title: 'ผิดพลาด', variant: 'danger', solid: true, toaster: 'b-toaster-top-right',
        })
      }
    },

    async reloadList() {
      this.currentPage = 1
      await this.getAdminList()
    },

    canEdit(item) {
      // Master admin can only be edited by themselves
      if (item.isMaster && item.adminID !== this.currentAdminID) return false
      return true
    },

    canDelete(item) {
      // Master admin cannot be deleted
      if (item.isMaster) return false
      // Don't allow deleting yourself
      if (item.adminID === this.currentAdminID) return false
      return true
    },

    canSetMaster() {
      // If no master exists, anyone can be set as master
      if (!this.existingMaster) return true
      // If editing, can keep master status if currently master
      if (this.isEdit && this.form.adminID === this.existingMaster.adminID) return true
      // If current user is master and editing self, keep checkbox
      if (this.isEdit && this.form.adminID === this.currentAdminID && this.isCurrentMaster) return true
      return false
    },

    async loadPermissionMenu(adminID) {
      try {
        const response = await axios.post(
          taobaoService_dotnet + 'app/Branch/get-permission-menu',
          {
            branchID: this.branchID,
            adminID: adminID || null,
          },
          { headers: header_token },
        )
        const menus = (response.data && response.data.menus) || []
        this.permissionRows = menus.map(m => ({
          permissionMenuID: m.permissionMenuID,
          nameTH: m.nameTH,
          nameEH: m.nameEH,
          parentID: m.parentID,
          orderNo: m.orderNo,
          authorize: m.authorize || 0,
        }))
      } catch (e) {
        console.error(e)
        this.permissionRows = []
      }
    },

    getChildren(parentID) {
      return this.permissionRows
        .filter(m => m.parentID === parentID)
        .slice()
        .sort((a, b) => (a.orderNo || 0) - (b.orderNo || 0))
    },

    toggleMenu(menu, checked, isParent) {
      const nextAuth = checked ? (menu.authorize > 0 ? menu.authorize : 2) : 0
      menu.authorize = nextAuth
      if (isParent) {
        const children = this.getChildren(menu.permissionMenuID)
        children.forEach(child => {
          child.authorize = nextAuth
        })
      } else if (checked && menu.parentID) {
        const parent = this.permissionRows.find(m => m.permissionMenuID === menu.parentID)
        if (parent && parent.authorize === 0) parent.authorize = nextAuth
      }
    },

    onAuthorizeChange(menu, value, isParent) {
      if (!isParent) return
      const children = this.getChildren(menu.permissionMenuID)
      children.forEach(child => {
        if (child.authorize > 0) child.authorize = value
      })
    },

    async openAddModal() {
      this.isEdit = false
      this.resetForm()
      await this.loadPermissionMenu(null)
      this.$refs['adminModal'].show()
    },

    async openEditModal(item) {
      this.isEdit = true
      this.resetForm()
      this.form.adminID     = item.adminID
      this.form.firstName   = item.firstName   || ''
      this.form.lastName    = item.lastName    || ''
      this.form.email       = item.email       || ''
      this.form.phoneNumber = item.phoneNumber || ''
      this.form.userID      = item.userID      || ''
      this.form.password    = ''
      this.form.isMaster    = !!item.isMaster
      await this.loadPermissionMenu(item.adminID)
      this.$refs['adminModal'].show()
    },

    hideModal() {
      this.resetForm()
    },

    resetForm() {
      this.loadButton       = true
      this.form.adminID     = null
      this.form.firstName   = ''
      this.form.lastName    = ''
      this.form.email       = ''
      this.form.phoneNumber = ''
      this.form.userID      = ''
      this.form.password    = ''
      this.form.isMaster    = false
      this.val.firstName    = null
      this.val.phoneNumber  = null
      this.val.userID       = null
      this.val.password     = null
      this.permissionRows   = []
    },

    validateForm() {
      let valid = true
      this.val.firstName   = this.form.firstName.trim()   !== '' ? null : false
      this.val.phoneNumber = this.form.phoneNumber.trim() !== '' ? null : false
      this.val.userID      = this.form.userID.trim()      !== '' ? null : false
      if (!this.isEdit) {
        this.val.password = this.form.password.trim() !== '' ? null : false
      } else {
        this.val.password = null
      }
      if (this.val.firstName === false ||
          this.val.phoneNumber === false ||
          this.val.userID === false ||
          this.val.password === false) {
        valid = false
      }
      return valid
    },

    buildPayload() {
      return {
        adminID: this.isEdit ? this.form.adminID : null,
        branchID: this.branchID,
        firstName: this.form.firstName.trim(),
        lastName: this.form.lastName.trim(),
        email: this.form.email.trim(),
        phoneNumber: this.form.phoneNumber.trim(),
        userID: this.form.userID.trim(),
        password: this.form.password.trim(),
        isMaster: this.form.isMaster,
        staffBranchID: this.currentAdminID,
        permissions: this.permissionRows.map(p => ({
          permissionMenuID: p.permissionMenuID,
          authorize: p.authorize || 0,
        })),
      }
    },

    async submitAdd() {
      if (!this.validateForm()) return
      this.loadButton = false
      try {
        const response = await axios.post(
          taobaoService_dotnet + 'app/Branch/add-edit-admin',
          this.buildPayload(),
          { headers: header_token },
        )
        if (response.data && response.data.status === 'success') {
          this.$refs['adminModal'].hide()
          await this.getAdminList()
          this.$bvToast.toast('เพิ่ม Admin สำเร็จ', {
            title: 'สำเร็จ', variant: 'success', solid: true, toaster: 'b-toaster-top-right',
          })
        } else {
          this.$swal({
            icon: 'warning',
            title: 'เพิ่ม Admin ไม่สำเร็จ',
            text: (response.data && response.data.message) || '',
            confirmButtonText: 'เข้าใจแล้ว',
            customClass: { confirmButton: 'btn btn-warning' },
            buttonsStyling: false,
          })
        }
      } catch (e) {
        console.error(e)
        this.$bvToast.toast('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง', {
          title: 'ผิดพลาด', variant: 'danger', solid: true, toaster: 'b-toaster-top-right',
        })
      } finally {
        this.loadButton = true
      }
    },

    async submitEdit() {
      if (!this.validateForm()) return
      this.loadButton = false
      try {
        const response = await axios.post(
          taobaoService_dotnet + 'app/Branch/add-edit-admin',
          this.buildPayload(),
          { headers: header_token },
        )
        if (response.data && response.data.status === 'success') {
          this.$refs['adminModal'].hide()
          await this.getAdminList()
          this.$bvToast.toast('แก้ไขข้อมูลสำเร็จ', {
            title: 'สำเร็จ', variant: 'success', solid: true, toaster: 'b-toaster-top-right',
          })
        } else {
          this.$swal({
            icon: 'warning',
            title: 'แก้ไขไม่สำเร็จ',
            text: (response.data && response.data.message) || '',
            confirmButtonText: 'เข้าใจแล้ว',
            customClass: { confirmButton: 'btn btn-warning' },
            buttonsStyling: false,
          })
        }
      } catch (e) {
        console.error(e)
        this.$bvToast.toast('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง', {
          title: 'ผิดพลาด', variant: 'danger', solid: true, toaster: 'b-toaster-top-right',
        })
      } finally {
        this.loadButton = true
      }
    },

    async confirmDelete(item) {
      if (!this.canDelete(item)) return
      const name = [item.firstName, item.lastName].filter(x => x).join(' ')
      this.$swal({
        icon: 'warning',
        title: 'ยืนยันการลบ',
        text: `ต้องการลบ Admin "${name}" ใช่หรือไม่?`,
        showCancelButton: true,
        confirmButtonText: 'ลบ',
        cancelButtonText: 'ยกเลิก',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-outline-secondary ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (!result.value) return
        try {
          const response = await axios.post(
            taobaoService_dotnet + 'app/Branch/delete-admin',
            {
              adminID: item.adminID,
              staffBranchID: this.currentAdminID,
            },
            { headers: header_token },
          )
          if (response.data && response.data.status === 'success') {
            await this.getAdminList()
            this.$bvToast.toast('ลบ Admin สำเร็จ', {
              title: 'สำเร็จ', variant: 'success', solid: true, toaster: 'b-toaster-top-right',
            })
          } else {
            this.$swal({
              icon: 'warning',
              title: 'ลบไม่สำเร็จ',
              text: (response.data && response.data.message) || '',
              confirmButtonText: 'เข้าใจแล้ว',
              customClass: { confirmButton: 'btn btn-warning' },
              buttonsStyling: false,
            })
          }
        } catch (e) {
          console.error(e)
          this.$bvToast.toast('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง', {
            title: 'ผิดพลาด', variant: 'danger', solid: true, toaster: 'b-toaster-top-right',
          })
        }
      })
    },
  },
}
</script>

<style scoped>
.permission-list {
  padding: 0.25rem 0;
}
.permission-row {
  display: flex;
  align-items: center;
  padding: 0.4rem 0.25rem;
}
.permission-name {
  flex: 0 0 55%;
  max-width: 55%;
}
.permission-indent {
  margin-left: 2rem;
}
.permission-radios {
  display: flex;
  align-items: center;
  white-space: nowrap;
  font-size: 1rem;
}
.permission-radios .custom-radio label,
.permission-radios label {
  font-size: 1rem;
}
</style>
